import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 25 32",
  "content": "<symbol viewBox=\"0 0 25 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"play\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24.1217 15.7664L0.865723 31.0281L0.865723 0.504639L24.1217 15.7664Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol